/* src/pages/admin/AdminUserForm.js (NEW FILE) */
import React, { useState } from 'react';

const AdminUserForm = ({ user, onSaveRole, onCancel }) => {
    const [selectedRole, setSelectedRole] = useState(user.role);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await onSaveRole(user.id, selectedRole);
        } catch (error) {
            alert('Failed to update role.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal-content">
                <h2>Edit User Role</h2>
                <p><strong>User:</strong> {user.name} ({user.email})</p>
                <form onSubmit={handleSubmit} className="admin-form">
                    <div className="form-group">
                        <label htmlFor="role">Role</label>
                        <select 
                            name="role" 
                            id="role" 
                            value={selectedRole} 
                            onChange={(e) => setSelectedRole(e.target.value)}
                        >
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                            <option value="reviewer">Reviewer</option>
                        </select>
                    </div>
                    <div className="form-actions">
                        <button type="button" onClick={onCancel} className="btn-secondary" disabled={isLoading}>
                            Cancel
                        </button>
                        <button type="submit" className="btn-primary" disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Role'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminUserForm;
